import type { ExtraCallFailedReason } from '@/providers/call-capabilities/call-capabilities-provider';
import { useMemo } from 'react';
import { useMicrophonePermission } from '../permissions/use-microphone-permission';

type CanCall =
  | {
      ok: true;
    }
  | {
      ok: false;
      reason: ExtraCallFailedReason;
    };

export const useCanCall = () => {
  const { hasMicrophonePermission } = useMicrophonePermission();

  const canCall: CanCall = useMemo(() => {
    if (hasMicrophonePermission !== 'granted') {
      return {
        ok: false,
        reason: 'microphone-permission',
      };
    }

    return {
      ok: true,
    };
  }, [hasMicrophonePermission]);

  return {
    canCall,
  };
};
